;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);
	var $page, $admin;
	$doc.ready(function() {
		$page = $('html, body');
		$admin = $('#admin_bar_iframe');

		$('.map').gmap({
			locations: '.locations'
		});
	});

 	/*
	 * Google Maps
	 */
	$.fn.gmap = function(customSettings) {

		var $map = $(this),
			pins = $map.data('pins');

			var settings = $.extend({
				locations: false
			}, customSettings);

		if ($map.length) {

			var myOptions = {
				zoom: 5,
				center: new google.maps.LatLng(0, 0),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				sensor: true,
				panControl: false,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				scrollwheel: false,
				overviewMapControl: false
			}

			var map = new google.maps.Map($map[0], myOptions);
			var bounds = new google.maps.LatLngBounds();

			if ( typeof settings.locations === 'string' ) {
				var image = null;
				var pin = $map.data('pin');

				if (pin) {
					image = {
						url: pin,
						scaledSize: new google.maps.Size(32, 47),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(16, 47),
						labelOrigin: new google.maps.Point(0, 5)
					};
				};

				$(settings.locations).find('> [data-lat][data-lng]').each(function(index, el) {
					var $location = $(this);

					var coordinates = new google.maps.LatLng( $location.data('lat') , $location.data('lng') );
					var marker = new google.maps.Marker({
						position: coordinates,
						label: {
							text: $location.data('id').toString() || null,
							fontFamily: 'sans-serif, serif, monospace'
						},
						icon: image,
						map: map
					});

					bounds.extend(coordinates);

					marker.addListener('click', function() {
						$page.animate({
							scrollTop: $location.offset().top - $admin.height()
						});
					});
				});
			};

			map.fitBounds(bounds);

			google.maps.event.addDomListener(window, 'resize', function() {
				var center = map.getCenter();
				google.maps.event.trigger(map, 'resize');
				map.setCenter(center);
			});

			$map.bind('mapResize' , function () {
				google.maps.event.trigger(map, 'resize');
				map.setCenter($map.data('marker').getPosition());

				map.setZoom(8);
			});
		};
		return map;
	};
})(jQuery, window, document);
